export default {
  namespaced: true,

  state: {
    requests: []
  },

  mutations: {
    add: (state, token) => state.requests.push(token),
    reset: state => (state.requests = [])
  },

  actions: {
    cancel({ state, commit }) {
      state.requests.forEach(request => request.cancel && request.cancel())
      commit('reset')
    }
  }
}
